module.exports = __webpack_public_path__ + "img/LZLogo.283a7857.png";